import { WorkData } from '@/data/types';
import workspaceWiki from './work/cases/workspace-wiki';
import schnack from './work/cases/schnack';
import sphairaConnect from './work/cases/sphaira-connect';
// import flux from './work/cases/flux'; // offline until the app is published
import hunyuan3dMlx from './work/cases/hunyuan3d-mlx';
import novatimepuncher from './work/cases/novatimepuncher';
// import kiKundendienstCockpit from './work/cases/ki-kundendienst-cockpit'; // offline until cleared by employer
import aiVideoTranscriptionAutomation from './work/cases/ai-video-transcription-automation';
import developmentOfRobinwichmannCom from './work/cases/development-of-robinwichmann_com';

const workData: WorkData = {
  title: "My Work",
  intro: "Here you'll find a selection of my recent projects. Each one reflects my approach of combining innovative design with technical excellence.",
  previewNotAvailable: "Preview not available",
  moreDetails: "More details",
  sections: {
    apps: {
      title: "Apps & Demos",
      intro: "Published apps and projects you can try out. Built, released and in active use."
    },
    blog: {
      title: "Project Blog",
      intro: "Case studies from my work, covering the challenge, the approach and the results in detail."
    }
  },
  contactCta: {
    text: "Interested in working together, or have questions about my projects?",
    buttonText: "Get in touch"
  },

  // Work Cases
  cases: [
    workspaceWiki,
    schnack,
    sphairaConnect,
    novatimepuncher,
    // flux, // offline until the app is published
    hunyuan3dMlx,
    // kiKundendienstCockpit, // offline until cleared by employer
    developmentOfRobinwichmannCom,
    aiVideoTranscriptionAutomation
  ]
};

export default workData;
